import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { NotificationManager } from '@atlas/core';
import { BasePopup, Icon, Label } from '@atlas/ui';

import InitializationForm from 'src/terminal/components/Initialization/InitializationForm';

const TerminalInitializationPopup = ({ data, id }) => {
  const { setTerminalKey, text, title } = data;
  const handleClose = useCallback(() => {
    NotificationManager.removeNotification(id);
  }, [id]);

  return (
    <BasePopup className="terminal-initialization-popup">
      <button className="close-popup" onClick={handleClose} type="button">
        <Icon name="close" />
      </button>
      <div className="popup__content">
        <Label className="popup__title" message={title} />
        <Label className="popup__text" message={text} />

        <InitializationForm handleClose={handleClose} setTerminalKey={setTerminalKey} />
      </div>
    </BasePopup>
  );
};

TerminalInitializationPopup.propTypes = {
  data: PropTypes.shape({
    setTerminalKey: PropTypes.func,
    text: PropTypes.string,
    title: PropTypes.string,
  }),
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default TerminalInitializationPopup;
